export function onChangeLanguage() {
  document.body.addEventListener('click', (event) => {
    const target = event?.detail?.target ?? event?.target;

    /**
     * click sobre el boton de selección de idiomas
     */
    if (target?.getAttribute('action') === 'language') {
      const parser = new URL(globalThis.location);
      parser.searchParams.set('lang', target.getAttribute('value'));
      globalThis.location = parser.href;
    }
  });
}
